import { Component } from 'react'
import moment from 'moment'
import { BsPersonBoundingBox, BsPersonVcard } from 'react-icons/bs'
import { FaUserDoctor, FaPeopleRoof, FaBuildingShield } from 'react-icons/fa6'
import { FaExpandArrowsAlt, FaClinicMedical, FaPrescription, FaRegWindowClose, FaDiagnoses, FaSignature } from 'react-icons/fa'
import { GiContract, GiMicroscope, GiPollenDust } from 'react-icons/gi'
import { MdOutlineSick } from 'react-icons/md'
import { TbVaccine } from 'react-icons/tb'
import { LiaFileMedicalAltSolid } from 'react-icons/lia'
import { FcGoodDecision, FcBadDecision } from 'react-icons/fc'
import PatientSmall from './PatientSmall'
import Patient from './Patient'
import AllergyIntolerance from './AllergyIntolerance'
import Encounter from './Encounter'
import Observation from './Observation'
import Condition from './Condition'
import Immmunization from './Immunization'
import DiagnosticReport from './DiagnosticReport'
import Procedure from './Procedure'
import MedicationRequest from './MedicationRequest'
import { Code, CodeableConcept, CodeableConcepts, Choice, OnsetDateTime, Result, Names, Period } from '../helpers'
import './calendar.css'

class Dashboard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            patients: [],
            pvdr: null,
            pidx: null,
            displayPatients: false,
            displayResource: false,
            resource: null,
            resources: [
                { resource: 'Patient', display: true, text: 'Demographics' },
                { resource: 'AllergyIntolerance', display: true, text: 'Allergies' },
                { resource: 'Condition', display: true, text: 'Conditions' },
                { resource: 'Immunization', display: true, text: 'Immunizations' },
                { resource: 'DiagnosticReport', display: true, text: 'Labs' },
                { resource: 'Procedure', display: true, text: 'Procedures' },
                { resource: 'MedicationRequest', display: true, text: 'Medications' }]
        }
    }

    componentDidMount() {
        if (this.props.providers) {
            const pidx = this.props.providers.findIndex(p => p.selected)
            this.setState({ pvdr: this.props.providers[0], pidx, patient: this.props.patient || null })
        }
    }

    handlePatientSelect(pidx) {
        //this.setState({ patient: this.props.patients[pidx], displayPatients: false, data: this.props.data[pidx].entry })
        // !!!YOU ARE HERE!!!
        // need to decide if we use props or state...
        // need to manage selected patients against full props list

        let idx = this.state.patients.findIndex(p => p.id === this.props.data[pidx].id)
        //console.log(pidx, idx)
        if (idx > -1) {
            this.setState({ patients: [...this.state.patients.slice(0, idx), ...this.state.patients.slice(idx + 1)] })
        } else this.setState({ patients: [...this.state.patients, this.props.data[pidx]] })

        //this.props.onPatientSelected(pidx)
    }

    handlePvdrSelected(pidx) {
        this.props.onPvdrSel(pidx)
        this.setState({ pvdr: this.props.providers[pidx], pidx })
    }

    handlePatientClick() {
        this.setState({ displayPatients: true, displayResource: false })
    }

    handleMore(pidx, res) {
        let eidx = this.state.patients[pidx].expand ? this.state.patients[pidx].expand.indexOf(res) : -1
        let expand = []
        if (eidx > -1) {
            expand = [...expand.slice(0, eidx), ...expand.slice(eidx + 1)]
        } else {
            expand = [res]
        }
        const patient = {...this.state.patients[pidx], expand}
        this.setState({ patients: [...this.state.patients.slice(0, pidx), patient, ...this.state.patients.slice(pidx + 1)] })
    }

    handleDisplayResource(pidx, res) {
        this.setState({ displayResource: true, resource: res })
    }

    handleCloseResource() {
        this.setState({ displayResource: false, resource: null })
    }

    handleMoreRight(pidx, v) {
        let patient = { ...this.state.patients[pidx], [v]: !this.state.patients[pidx][v] }
        this.setState({ patients: [...this.state.patients.slice(0, pidx), patient, ...this.state.patients.slice(pidx + 1)] })
    }

    handleClosePatients() {
        this.setState({ displayPatients: false })
    }

    getPatients() {
        return this.props.patients.length > 0 ? <div className='Appt-Form-Row'>
            <div className='Window-Close' onClick={() => this.handleClosePatients()}><div className='Appt-Form-Close'><FaRegWindowClose /></div></div>
            <div className='Cal-Flex-Wrap Appt-Patients'>
                {
                    this.props.patients.map((m, midx) => {
                        return <div className={`Appt-Patient`} key={`member-${midx}`} onClick={() => this.handlePatientSelect(midx)}>
                            <PatientSmall resource={m} />
                        </div>
                    })
                }
            </div>
            <div className='Appt-Form-Row Cal-Flex-Wrap'>
                <div style={{ cursor: 'pointer' }} onClick={() => this.handleFetchPatients('signature')}>
                    <div className='DB-Logo'><div style={{ marginTop: '-2px' }} className='DS-Flex-Wrap'><FaSignature /><FaBuildingShield /></div></div>
                    <div className='DB-Logo-Text'>Request Patient Longitudinal Record</div>
                </div>
                {
                    this.props.groups && this.props.groups.map((g, gidx) => {
                        return <div key={`group-${gidx}`} className='Group-Container' onClick={() => g.resource.code.coding.findIndex(c => c.code === 'pdexprovidergroup') > -1 && this.handleGroupFetch(g.resource.id, g.resource.member.map(m => m.entity))}>
                            <div className='Group-Label'>{CodeableConcept(g.resource.code)}</div>
                            <div className='Group-Icon'>{g.resource.code.coding.findIndex(c => c.code === 'pdexprovidergroup') > -1 ? <FcGoodDecision /> : <FcBadDecision />}</div>
                            <div className='Group-Label'>{`${g.resource.member.length} ${g.resource.member.length === 1 ? 'Patient' : 'Patients'} ${g.resource.code.coding.findIndex(c => c.code === 'pdexprovidergroup') > -1 ? 'Available' : 'Unavailable'}`}</div>
                        </div>
                    })
                }
            </div>
        </div> : null
    }

    getProviders() {
        return this.props.providers ? <div className='Cal-Providers-Container'>
            <div className='Cal-Providers-Header'>
                <div className='Cal-Providers-CB'>
                    <FaUserDoctor />
                </div>
                <div className='Cal-Providers-Text'>
                    Last
                </div>
                <div className='Cal-Providers-Text'>
                    First
                </div>
                <div className='Cal-Providers-Text'>
                    Specialty
                </div>
            </div>
            {
                this.props.providers.map((pvdr, pidx) => {
                    return <div key={`pvdr-${pidx}`} className={`Cal-Providers-Row${pidx === this.state.pidx ? ' Cal-Providers-Row-Sel' : (pidx % 2 ? '' : ' Cal-Providers-Row-Alt')}`}>
                        <div className='Cal-Providers-CB'>
                            <input type="checkbox" checked={pidx === this.state.pidx} onChange={(event) => this.handlePvdrSelected(pidx)} />
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.last}
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.first}
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.specialty}
                        </div>
                    </div>
                })
            }
        </div> : null
    }

    getIcon(res) {
        switch (res) {
            case 'AllergyIntolerance':
                return <GiPollenDust />
            case 'Condition':
                return <MdOutlineSick />
            case 'DiagnosticReport':
                return <FaDiagnoses />
            case 'Encounter':
                return <FaPeopleRoof />
            case 'Immunization':
                return <TbVaccine />
            case 'MedicationRequest':
                return <FaPrescription />
            case 'Observation':
                return <GiMicroscope />
            case 'Patient':
                return <BsPersonVcard />
            case 'Procedure':
                return <LiaFileMedicalAltSolid />
            default:
                return <FaClinicMedical />
        }
    }

    getResources(pidx, resource) {
        return this.state.resources.map((res, ridx) => {
            return <div key={`res-${ridx}`} className='DB-List-Container'>
                <div className='Cal-Row Cal-Flex'>
                    <div className='DB-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon(res.resource)}</span>{res.text}</div>
                    <div className='DB-Divider'></div>
                    <div className='DB-Divider-Button' onClick={() => this.handleMore(pidx, res.resource)}>{!this.state.patients[pidx].expand || this.state.patients[pidx].expand.indexOf(res.resource) === -1 ? <GiContract /> : <FaExpandArrowsAlt />}</div>
                </div>
                {
                    resource.filter(d => d.resource.resourceType === res.resource && (!this.state.patients[pidx].expand || this.state.patients[pidx].expand.indexOf(res.resource) === -1)).map((r, residx) => {
                        return <div key={`${res.resource}-${residx}`} className={`Cal-Flex DB-List-Row${residx % 2 ? '-Alt' : ''}`} onClick={() => this.handleDisplayResource(pidx, r)}>
                            {r.resource.name && <div className='DB-List-Item'>{Names(r.resource.name)}</div>}
                            {r.resource.gender && <div className='DB-List-Item'>({r.resource.gender})</div>}
                            {r.resource.birthDate && <div className='DB-List-Item'>DOB: {moment(r.resource.birthDate).format('ll')}</div>}
                            {r.resource.type && <div className='DB-List-Item'>{Code(r.resource.type)}</div>}
                            {r.resource.category && <div className='DB-List-Item'>({res.resource === 'DiagnosticReport' ? CodeableConcepts(r.resource.category) : Code(r.resource.category)})</div>}
                            {r.resource.code && <div className='DB-List-Item'>{CodeableConcept(r.resource.code)}</div>}
                            {r.resource.medicationCodeableConcept && <div className='DB-List-Item'>{CodeableConcept(r.resource.medicationCodeableConcept)}</div>}
                            {r.resource.onsetDateTime && <div className='DB-List-Item'>{OnsetDateTime(r.resource.onsetDateTime)}</div>}
                            {r.resource.effectiveDateTime && <div className='DB-List-Item'>{Choice('DateTime', r.resource.effectiveDateTime)}</div>}
                            {r.resource.vaccineCode && <div className='DB-List-Item'>{CodeableConcept(r.resource.vaccineCode)}</div>}
                            {r.resource.result && <div className='DB-List-Item'>{Result(r.resource.result)}</div>}
                            {r.resource.performedDateTime && <div className='Res-Detail'>{Choice('DateTime', r.resource.performedDateTime)}</div>}
                            {r.resource.performedString && <div className='Res-Detail'>{Choice('String', r.resource.performedString)}</div>}
                            {r.resource.performedPeriod && <div className='Res-Detail'>{Choice('Period', r.resource.performedPeriod)}</div>}
                            {r.resource.performedAge && <div className='Res-Detail'>{Choice('Age', r.resource.performedAge)}</div>}
                            {r.resource.performedRange && <div className='Res-Detail'>{Choice('Range', r.resource.performedRange)}</div>}
                            {r.resource.authoredOn && <div className='Res-Detail'>{moment(r.resource.authoredOn).format('lll')}</div>}
                        </div>
                    })
                }
            </div>
        })
    }

    getResource(res) {
        switch (res.resource.resourceType) {
            case 'AllergyIntolerance':
                return <AllergyIntolerance resource={res.resource} />
            case 'Condition':
                return <Condition resource={res.resource} />
            case 'DiagnosticReport':
                return <DiagnosticReport resource={res.resource} />
            case 'Encounter':
                return <Encounter resource={res.resource} />
            case 'Immunization':
                return <Immmunization resource={res.resource} />
            case 'MedicationRequest':
                return <MedicationRequest resource={res.resource} />
            case 'Observation':
                return <Observation resource={res.resource} />
            case 'Procedure':
                return <Procedure resource={res.resource} />
            default:
                return <Patient resource={res.resource} />
        }
    }

    getResourceView() {
        return <div className='DB-Resource-Container'>
            <div className='DB-Resource-Header' onClick={() => this.handleCloseResource()}>
                <div className='Appt-Form-Close'><FaRegWindowClose /></div>
            </div>
            <div className='DB-Resource-Body'>
                {this.getResource(this.state.resource)}
            </div>
        </div>
    }

    getVisits(pidx) {
        //fix the this.state.visits - move it to the resource
        return <div className='DB-List-Container'>
            <div className='Cal-Row Cal-Flex'>
                <div className='DB-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon('Encounter')}</span>Visits</div>
                <div className='DB-Divider'></div>
                <div className='DB-Divider-Button' onClick={() => this.handleMoreRight(pidx, 'visits')}>{!this.state.patients[pidx].visits ? <GiContract /> : <FaExpandArrowsAlt />}</div>
            </div>
            {
                this.state.patients[pidx].entry.filter(d => d.resource.resourceType === 'Encounter' && !this.state.patients[pidx].visits).map((r, residx) => {
                    return <div key={`visits-${pidx}-${residx}`} className={`Cal-Flex DB-List-Row${residx % 2 ? '-Alt' : ''}`} onClick={() => this.handleDisplayResource(pidx, r)}>
                        {r.resource.type && <div className='DB-List-Item'>{CodeableConcepts(r.resource.type)}</div>}
                        {r.resource.reasonCode && <div className='DB-List-Item'>{CodeableConcepts(r.resource.reasonCode)}</div>}
                        {r.resource.period && <div className='DB-List-Item'>{Period(r.resource.period)}</div>}
                    </div>
                })
            }
        </div>
    }

    getVitals(pidx) {
        //fix the this.state.vitals - move it to the resource
        return <div className='DB-List-Container'>
            <div className='Cal-Row Cal-Flex'>
                <div className='DB-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon('Observation')}</span>Vitals</div>
                <div className='DB-Divider'></div>
                <div className='DB-Divider-Button' onClick={() => this.handleMoreRight(pidx, 'vitals')}>{!this.state.patients[pidx].vitals ? <GiContract /> : <FaExpandArrowsAlt />}</div>
            </div>
            {
                this.state.patients[pidx].entry.filter(d => d.resource.resourceType === 'Observation' && !this.state.patients[pidx].vitals).map((r, residx) => {
                    return <div key={`visits-${pidx}-${residx}`} className={`Cal-Flex DB-List-Row${residx % 2 ? '-Alt' : ''}`} onClick={() => this.handleDisplayResource(pidx, r)}>
                        {r.resource.category && <div className='DB-List-Item'>{CodeableConcepts(r.resource.category)}</div>}
                        {r.resource.code && <div className='DB-List-Item'>{CodeableConcept(r.resource.code)}</div>}
                        {r.resource.effectiveDateTime && <div className='DB-List-Item'>{Choice('DateTime', r.resource.effectiveDateTime)}</div>}
                        {r.resource.effectivePeriod && <div className='DB-List-Item'>{Choice('Period', r.resource.effectivePeriod)}</div>}
                        {r.resource.effectiveTiming && <div className='DB-List-Item'>{Choice('Timing', r.resource.effectiveTiming)}</div>}
                        {r.resource.effectiveInstant && <div className='DB-List-Item'>{Choice('Instant', r.resource.effectiveInstant)}</div>}
                        {r.resource.valueQuantity && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueQuantity)}</div>}
                        {r.resource.valueCodeableConcept && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueCodeableConcept)}</div>}
                        {r.resource.valueString && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueString)}</div>}
                        {r.resource.valueBoolean && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueBoolean)}</div>}
                        {r.resource.valueInteger && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueInteger)}</div>}
                        {r.resource.valueRange && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueRange)}</div>}
                        {r.resource.valueRatio && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueRatio)}</div>}
                        {r.resource.valueSampleData && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueSampleData)}</div>}
                        {r.resource.valueTime && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueTime)}</div>}
                        {r.resource.valueDateTime && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valueDateTime)}</div>}
                        {r.resource.valuePeriod && <div className='DB-List-Item'>{Choice('Quantity', r.resource.valuePeriod)}</div>}
                    </div>
                })
            }
        </div>
    }

    render() {
        console.log(this.props, this.state)
        return <div className='Cal-Container'>
            <div className='Cal-Col' style={{ width: '345px' }}>
                {this.getProviders()}
                <div className='Cal-Clinic'>Signature Florida Medical Clinic</div>
                <div className='Appt-Form-Patient-Container' style={{ cursor: 'pointer', marginTop: '10px' }} onClick={() => this.handlePatientClick()}>
                    {this.state.patients.length > 0 ?
                        this.state.patients.map((pat, patidx) => {
                            //console.log('PAT',pat)
                            return <PatientSmall key={`patient-${patidx}`} resource={pat.entry[pat.entry.findIndex(p => p.resource.resourceType === 'Patient')].resource} />
                        }) : <div style={{ fontSize: '48pt' }}><BsPersonBoundingBox /></div>}
                </div>
            </div>
            <div style={{ width: 'calc(100% - 355px)' }}>
                {this.state.patients.length > 0 && <div className='Appt-Form-Row Appt-Section-Header'>
                    <div>{moment(this.props.date).format('lll')}</div>
                </div>}
                {this.state.displayPatients && <div className='Cal-Col'>{this.getPatients()}</div>}
                {!this.state.displayPatients && <div className='Cal-Col' style={{}}>
                    {
                        this.state.patients.map((p, pidx) => {
                            return <div key={`pp-${pidx}`} className='Cal-Flex-Wrap' style={{ marginBottom: '10px', borderBottom: '3px solid #000' }}>
                                <div className='Cal-Col' style={{ width: 'calc(100% - 350px)' }}>
                                    {this.getResources(pidx, p.entry)}
                                    {this.state.displayResource && this.state.resource && this.getResourceView()}
                                </div>
                                <div className='Cal-Col' style={{ width: '325px' }}>
                                    {this.getVisits(pidx)}
                                    {this.getVitals(pidx)}
                                </div>
                            </div>
                        })
                    }
                </div>}
            </div>
        </div>







    }
}

export default Dashboard